import { memo } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { EmptyStateCell } from './EmptyStateCell';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailCell = ({
  value
}) => {
  if (!value) {
    return /*#__PURE__*/_jsx(EmptyStateCell, {});
  }
  const mailto = `mailto:${value}`;
  return /*#__PURE__*/_jsx(Link, {
    external: true,
    href: mailto,
    truncate: true,
    children: value
  });
};
export default /*#__PURE__*/memo(EmailCell);